import { render, staticRenderFns } from "./transportationType.vue?vue&type=template&id=d4d9166a&"
import script from "./transportationType.vue?vue&type=script&lang=js&"
export * from "./transportationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4d9166a')) {
      api.createRecord('d4d9166a', component.options)
    } else {
      api.reload('d4d9166a', component.options)
    }
    module.hot.accept("./transportationType.vue?vue&type=template&id=d4d9166a&", function () {
      api.rerender('d4d9166a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/transportationType.vue"
export default component.exports